<template>
<div id="login">
  <div class="row no-gutters align-items-center">
    <div class="col">
      <div v-if="$store.state.isLoggedIn">
        <button type="submit" class="btn btn-primary" v-on:click.stop.prevent="logout">Logout</button>
      </div>
      <form class="login-form" v-else>
        <h1 class="text-center">Welcome</h1>
        <div class="form-group">
          <input type="text" class="form-control" required id="username" placeholder="Username" v-model="username" />
        </div>
        <div class="form-group">
          <input type="password" class="form-control" required id="password" placeholder="Password" v-model="password" />
        </div>
        <div class="row align-items-center">
          <div class="col">
            <button type="submit" class="btn btn-primary" v-on:click.stop.prevent="login">Login</button>
          </div>
          <div class="col">
            <div v-if="error" class="text-danger text-right">{{error}}</div>
          </div>
        </div>
      </form>
    </div>
    <div class="col">
      <div id="login-wallpaper">
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'Property',
  props: ['id'],
  data: function() {
    return {
      username: '',
      password: '',
      error: ''
    }
  },
  methods: {
    login: function() {
      this.error = '';
      this.$store.dispatch('login', {
        username: this.username,
        password: this.password
      }).then(res => {
        if(this.$store.state.role === 'admin') {
          this.$router.push('/');
        } else {
          this.$router.push('/stories');
        }
      }).catch((error) => {
        this.error = 'Ανεπιτυχής σύνδεση';
      });
    },
    logout: function() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    }
  }
}
</script>
